import { render, staticRenderFns } from "./VisitedTags.vue?vue&type=template&id=716f73d8&scoped=true"
import script from "./VisitedTags.vue?vue&type=script&lang=js"
export * from "./VisitedTags.vue?vue&type=script&lang=js"
import style0 from "./VisitedTags.vue?vue&type=style&index=0&id=716f73d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f73d8",
  null
  
)

export default component.exports